import React from 'react';
import Hero from '../components/Hero';
import ProductsOverview from '../components/ProductsOverview';
import Features from '../components/Features';
import Integration from '../components/Integration';
import './Home.css';

const Home = ({ selectedProduct, onProductChange, onContactClick }) => {
  return (
    <div className="home">
      <Hero
        selectedProduct={selectedProduct}
        onProductChange={onProductChange}
        onContactClick={onContactClick}
      />
      <ProductsOverview
        onProductChange={onProductChange}
        onContactClick={onContactClick}
      />
      <Features selectedProduct={selectedProduct} onContactClick={onContactClick} />
      <Integration selectedProduct={selectedProduct} onContactClick={onContactClick} />
    </div>
  );
};

export default Home; 